import Map, { Marker, Popup, NavigationControl } from "react-map-gl";
import Footer from "../components/Footer";
import ideasData from "../data/ideasData.json";
import { useEffect, useState } from "react";
import Pin from "../components/Pin";
import PopUpContent from "../components/PopUpContent";

function Discover() {
    const [markers, setMarkers] = useState([]);
    const [popUps, setPopUps] = useState([]);

    function createAllMarkers() {
        const markers = []

        ideasData.forEach(ideasEntry => {
            ideasEntry.coordinates.forEach((coordinate) => {
                const marker = <Marker 
                    key={`${ideasEntry.id}_${coordinate.lng}_${coordinate.lat}`}
                    id={ideasEntry.id} 
                    longitude={coordinate.lng} 
                    latitude={coordinate.lat}
                    onClick={(e) => {
                        e.originalEvent.stopPropagation(); 
                        clickMarker(ideasEntry, coordinate);
                    }}
                >
                    <Pin color={ideasEntry.color} />
                </Marker>

                markers.push(marker);
            })
        })

        return markers;
    }

    function clickMarker(ideasEntry, coordinate) {
        const popUp = <Popup 
            key={ideasEntry.id} 
            longitude={coordinate.lng} 
            latitude={coordinate.lat} 
            maxWidth={`${definePopUpMaxWidth()}vw`}
            offset={60} 
            closeButton={false} 
            closeOnClick={false}
        >
            <PopUpContent ideaData={ideasEntry} />
        </Popup>

        setPopUps([popUp]);
    }

    function clickMap() {
        setPopUps([]);
    }

    function definePopUpMaxWidth() {
        if (isSmallDevice()) return 60;
        return 50;
    }

    function isSmallDevice() {
        return window.innerWidth < 429;
      }

    useEffect(() => {
        setMarkers(() => createAllMarkers());
    }, [])

    return (
        <div className="Discover">
            <Map
                className="Map"
                mapboxAccessToken="pk.eyJ1Ijoicm9tZG9lbmVyIiwiYSI6ImNtZmsyMnFoODE2dWoyanM0emFva281cjQifQ.lTeUDcOIsvaO9FIagKnn-g"
                initialViewState={{
                    longitude: 8.680000,
                    latitude: 50.110000,
                    zoom: 12
                }}
                mapStyle="mapbox://styles/mapbox/light-v10"
                onClick={clickMap}
            >
                { markers }
                { popUps }
                {!isSmallDevice() && <NavigationControl showZoom="true" position="bottom-left" />}
            </Map>
            <Footer />
        </div>
    )
}

export default Discover;
